import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { useLocation } from "react-router-dom";
import Menubar from "./Menu";
import MenuContent from "./MenuContent";

const { Sider, Content: AntContent } = Layout;

const SetupPage = () => {
  const [selectedItem, setSelectedItem] = useState("Object Manager");
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/setup")) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [location]);

  return (
    <Layout style={{ height: "88vh", width: "100%", overflow: "hidden" }}>
      {/* Sidebar */}
      <Sider
        width="20%"
        style={{
          backgroundColor: "#f0f2f5",
        }}
      >
        <Menubar onSelect={setSelectedItem} selectedItem={selectedItem} />
      </Sider>

      {/* Content */}
      <AntContent
        style={{
          padding: "12px",
          backgroundColor: "#fff",
          overflowY: "auto", // independent scroll
        }}
      >
        <MenuContent selectedItem={selectedItem} />
      </AntContent>
    </Layout>
  );
};

export default SetupPage;
